$(document).ready(function(){

	var lang = 'nl';
	var plural = true; // delen is plural
	$('.langEn').hide(); 
	$('.langNl').show(); 
	$('.langFr').hide(); 

	/*  -------------------- NAV */
/*	$('.m-menu').click(function(){
	    $('html, body').toggleClass('noscroll');
	    $('body').toggleClass('m-menu-open');
	});
 */

	
	$('.js-launch-en').click(function() {
		lang = 'en';
		$('.langEn').show(); 
		$('.langNl').hide(); 
		$('.langFr').hide(); 
		$('.firstname').attr("placeholder", "First Name");
		$('.lastname').attr("placeholder", "Last Name");
		$('.streetnr').attr("placeholder", "Street + Nr");
		$('.zip').attr("placeholder", "Zip Code");
		$('.city').attr("placeholder", "City");
		$('.country').attr("placeholder", "Country");
		$('.natsecuritynumber').attr("placeholder", "National Insurance Number");
		$('.othername').attr("placeholder", "Name");
		$('.custom-checkbox-tax span').html('Tax Certificate? I agree to the inclusion of the information provided below.');
		$('.custom-checkbox-participants span').html('Include me in the participants list. If unchecked you will appear as anonymous.');
		$('.custom-checkbox-gift span').html('Gift? The name below will appear in the participants list.');
		$('.custom-checkbox-newsletter span').html('Subscribe me to MDD’s newsletter.');

		doLangPartsPlural();	

	});
	$('.js-launch-nl').click(function() {
		lang = 'nl';
		$('.langEn').hide(); 
		$('.langNl').show(); 
		$('.langFr').hide(); 
		$('.firstname').attr("placeholder", "Voornaam");
		$('.lastname').attr("placeholder", "Achternaam");
		$('.streetnr').attr("placeholder", "Straat + Nr");
		$('.zip').attr("placeholder", "Postcode");
		$('.city').attr("placeholder", "Stad");
		$('.country').attr("placeholder", "Land");
		$('.natsecuritynumber').attr("placeholder", "Rijksregisternummer");

		$('.othername').attr("placeholder", "Naam");
		
		$('.custom-checkbox-tax span').html('Fiscaal attest? Ik geef toestemming dat onderstaande gegevens gebruikt worden.');
		$('.custom-checkbox-participants span').html('Vermeld mij in de deelnemerslijst. Indien niet aangevinkt zal uw naam als anoniem verschijnen.');
		$('.custom-checkbox-gift span').html('Geschenk? De hieronder vermelde naam zal in de lijst verschijnen.');
		$('.custom-checkbox-newsletter span').html('Schrijf me in op de nieuwsbrief.');

		doLangPartsPlural();	
		
	});
	$('.js-launch-fr').click(function() {
		lang = 'fr';
		$('.langEn').hide(); 
		$('.langNl').hide(); 
		$('.langFr').show(); 
		$('.firstname').attr("placeholder", "Prénom");
		$('.lastname').attr("placeholder", "Nom");
		$('.streetnr').attr("placeholder", "Rue + numéro");
		$('.zip').attr("placeholder", "Code postal");
		$('.city').attr("placeholder", "Ville");
		$('.country').attr("placeholder", "Pays");
		$('.natsecuritynumber').attr("placeholder", "Numéro de registre nationa");
		$('.othername').attr("placeholder", "Nom");
		$('.custom-checkbox-tax span').html('Attestation fiscale? J’autorise l’inclusion des informations ci-dessous.');
		$('.custom-checkbox-participants span').html('Ajoutez-moi à la liste des participants. Sans quoi, vous resterez anonyme.');
		$('.custom-checkbox-gift span').html('Cadeau? Utilisez le nom ci-dessous dans la liste des participants.');
		$('.custom-checkbox-newsletter span').html("Je m’abonne à la newsletter.");

		doLangPartsPlural();	
	});
	
	function doLangPartsPlural() {
		// en
		if (lang == 'en' && plural == false) {
			$('.partLang').html('part')
		}
		if (lang == 'en' && plural == true) {
			$('.partLang').html('parts')
		}
		if (lang == 'nl' && plural == false) {
			$('.partLang').html('deel')
		}
		if (lang == 'nl' && plural == true) {
			$('.partLang').html('delen')
		}
		// fr
		if (lang == 'fr' && plural == false) {
			$('.partLang').html('part')
		}
		if (lang == 'fr' && plural == true) {
			$('.partLang').html('parts')
		}
	}
	
	/*  
	-------------------- SHOP
	 */
	 var totalsum = 0;
	 var myShoppingItems = [];

console.log(soldTiles);
	 // to do: check if it's in the basket already!
	function addToShoppingBasket(tileId) {

		// 1 check if it it's more or less valid
		if (tileId.indexOf('T') == -1) {
			//console.log('not valid');
			return false;
		}

		// 2 check if it's already sold
		isItInTheSoldTiles = soldTiles.includes(tileId);
		if (isItInTheSoldTiles) {
			console.log('isItInTheSoldTiles'+isItInTheSoldTiles);
			return false;
		}
		// 3 check if it's already on your list and maybe you want to cancel
		isItInTheShoppingList = myShoppingItems.includes(tileId);
		if (isItInTheShoppingList) {
			// remove from shopping list
			const index = myShoppingItems.indexOf(tileId);
			if (index > -1) {
			  myShoppingItems.splice(index, 1);
			} 
			$('#'+tileId).removeClass('almost-sold');
		} else {
			console.log(myShoppingItems);
			console.log('-- adding');
			myShoppingItems.push(tileId);
			console.log(myShoppingItems);
			$('#'+tileId).addClass('almost-sold');
		}
		
		doTheShoppingBasketCalc();
		
	}

	function colorTheMatrix() {
		soldTiles.forEach(tile => {
			tile = tile.trim();
			$('#'+tile).addClass('sold');
		});
	}

	function doTheShoppingBasketCalc(item) {
		$(".number").html(myShoppingItems.length);
		
		if (myShoppingItems.length == 0 || myShoppingItems.length > 1) {
			plural = true;
			doLangPartsPlural();
		} else {
			plural = false;
			doLangPartsPlural();
		}
		totalsum = myShoppingItems.length * 150;
		$(".totalsum").html(totalsum);
		$("input[name=amount]").val(totalsum); 
		$(".totaltile").html(myShoppingItems.length);
		$("#productDetail").val(myShoppingItems);
		$("#nav-shopping-basket .number").fadeOut(300).fadeIn(300).fadeOut(300).fadeIn(300);
	}
	
	$('.shop-checkbox').click(function() {
		if($('#differentName').prop('checked') == true){
			$('#other-name-fields').show();
		} else {
			$('#other-name-fields').hide();
		}
		if($('#hasNationalInsuranceNumber').prop('checked') == true){
			$('#nationalInsuranceNumber-fields').show();
		} else {
			$('#nationalInsuranceNumber-fields').hide();
		}
		
	});
	
	colorTheMatrix();
	
	
  	/* 
	  -------------------- OVERLAY
  	*/
	function disableAllNav() {
	   $("#nav-about").removeClass('active');
	}
	function modalOpened() {
		$("body").addClass('overlay-open');
	}
	function closeAllModals() {
		$("body").removeClass('overlay-open');
		$("body").removeClass('overlay-open-checkout');
		$( "#shop-map").hide();
		$( "#shopping-cart").hide();
	}
	
	// SHOPPING CART 
	$( ".js-launch-shop").click(function() {
		$( "#shopping-cart").hide();
		$( "#shop-map").fadeToggle( "fast", function() { 
			disableAllNav(); 
			modalOpened()
		});
	});
	$( ".js-close-shop").click(function() {
		$( "#shop-map").fadeToggle( "fast", function() { 
			disableAllNav();
			closeAllModals();
		 });
	});
	
	// SHOPPING CART 
	$( ".js-launch-checkout").click(function() {
		$( "#shop-map").hide();
		$("body").addClass('overlay-open-checkout');
		$( "#shopping-cart").fadeToggle( "fast", function() { 
			disableAllNav(); 
			modalOpened();
		});
	});
	$( ".js-close-basket").click(function() {
		disableAllNav(); 
		closeAllModals();	
	
	});
	
	
	 
	/* 
	 -------------------- SVG IMAGE
	*/
	
	function calculateWidth() {
		winHeight = window.innerHeight - 100 - 50; // - header - "footer"
		svgHeight  = $( "#svgImage" ).height();
		winWidth  = window.innerWidth;
		var width = 100;
		
		// scss $grid-mobile-breakpoint
		if (winWidth > 680) {
			console.log('winHeight:'+ winHeight + ' / svgHeight:' + svgHeight);
			width = (100/svgHeight) * winHeight;
			if (width > 100) {
				width = 100;
			}
		} else {
			width = 160;
		}

		console.log('---->'+width);

		$( "#svgImage" ).css('width', width+'%');

	}
	// run it fur the first time
	calculateWidth();
	
	$( window ).resize(function() {
		calculateWidth();
	});
		
  	const svgImage = document.getElementById("svgImage");
	const svgContainer = document.getElementById("svgContainer");
	const windowWidth 	= window.innerWidth;

	/* var svgFixedWidth = 1366;
	var scale = ((100/svgFixedWidth) * windowWidth)/100;
	console.log(scale);
	
	var viewBox = {x:0,y:0, w:1366, h:768};
    svgImage.setAttribute('viewBox', `${viewBox.x} ${viewBox.y} ${viewBox.w} ${viewBox.h}`);
	const svgSize = {
		w:svgImage.clientWidth,
		h:svgImage.clientHeight
	};

	var isPanning = false;
	var startPoint = {x:0,y:0};
	var endPoint = {x:0,y:0};;
	// var scale = scale;

	function scaling(e) {
		e.preventDefault();
		var w = viewBox.w;
	    var h = viewBox.h;
	    var mx = e.offsetX;//mouse x  
	    var my = e.offsetY;    
	    var dw = w*Math.sign(e.deltaY)*0.05;
	    var dh = h*Math.sign(e.deltaY)*0.05;
	    var dx = dw*mx/svgSize.w;
	    var dy = dh*my/svgSize.h;
	    viewBox = {x:viewBox.x+dx,y:viewBox.y+dy,w:viewBox.w-dw,h:viewBox.h-dh};
	    scale = svgSize.w/viewBox.w;
	    zoomValue.innerText = `${Math.round(scale*100)/100}`;
	    svgImage.setAttribute('viewBox', `${viewBox.x} ${viewBox.y} ${viewBox.w} ${viewBox.h}`);
	} */
	svgContainer.ontouchmove = function(e) {
		//svgContainer.style.backgroundColor = "red";
		// scaling(e);
	}
	svgContainer.onmousewheel = function(e) {
		// scaling(e);
	}
	svgContainer.onmousedown = function(e){
		
		if (e.path) {
			tileId = e.path[0].id; // chrome
		} else if (e.originalTarget) {
		  	tileId = e.originalTarget.id; // firefox
		}else if (e.composedPath) {
			tileId = e.target.id; // safari
		} else {
			alert('Browser is not supported. Try a up to date Browser (eg Chrome).')
		}
		  
		addToShoppingBasket(tileId);
	}

	svgContainer.onmousemove = function(e){

	}

	svgContainer.onmouseup = function(e){

	}

	svgContainer.onmouseleave = function(e){
	 // isPanning = false;
	}



});